import React from 'react';
import { HandwritingText } from '../../../shared/ui/handwriting-text';
import {
  Banner,
  Coin1,
  Coin2,
  Coin3,
  Count,
  Line1,
  Line2,
  RateBadge,
  Stats,
  Title,
  Trophy,
  TrophyWrap,
} from './ResultBanner.styles';

export interface ResultBannerProps {
  trophy: string;
  coin: string;
  titleLine1: string;
  titleLine2: string;
  /** true 면 타이틀 손글씨 등장 애니메이션 사용 */
  animateTitle?: boolean;
  /** animateTitle 일 때 true 가 되면 필기 시작 */
  titlePlaying?: boolean;
}

/** 결과 배너 (widget) — 트로피 + 결과 타이틀("내가 선택한 메뉴가 / 1위!"). */
export function ResultBanner({
  trophy,
  coin,
  titleLine1,
  titleLine2,
  animateTitle = false,
  titlePlaying = false,
}: ResultBannerProps) {
  const line1CharDelay = 52;
  const line1Duration = titleLine1.length * line1CharDelay;
  const line2StartDelay = line1Duration + 140;

  return (
    <Banner>
      <Title aria-label={`${titleLine1} ${titleLine2}`}>
        <Line1>
          <HandwritingText
            text={titleLine1}
            animate={animateTitle}
            playing={titlePlaying}
            charDelay={line1CharDelay}
          />
        </Line1>
        <Line2>
          <HandwritingText
            text={titleLine2}
            animate={animateTitle}
            playing={titlePlaying}
            startDelay={animateTitle ? line2StartDelay : 0}
            charDelay={64}
          />
        </Line2>
      </Title>

      <TrophyWrap aria-hidden="true">
        <Trophy src={trophy} alt="" width="55" height="54" />
        <Coin1 src={coin} alt="" />
        <Coin2 src={coin} alt="" />
        <Coin3 src={coin} alt="" />
      </TrophyWrap>
    </Banner>
  );
}

export interface WinnerStatsProps {
  ratePercent: number;
  voteCount: number;
  className?: string;
}

const numberFormatter = new Intl.NumberFormat('ko-KR');

/** 우승 통계 — 골드 rate 배지 + "N 득표". 우승 카드 바로 아래 배치. */
export function WinnerStats({ ratePercent, voteCount, className }: WinnerStatsProps) {
  return (
    <Stats className={className}>
      <RateBadge>{ratePercent}%</RateBadge>
      <Count>{numberFormatter.format(voteCount)} 득표</Count>
    </Stats>
  );
}
